module.exports = __webpack_public_path__ + "static/monkeyspin-586f5b1851d47335a80f6982e64b60c2.webp";